import timesheet from "../timesheet";

const state = {
    servicerequests: [],
    serviceOrderList: [],
    servicerequestDocuments: [],
    serviceOrderDocuments:[],
    serviceOne: [],
    serviceOrderOne: [],

    serviceOrder: [],
    timesheet: [],
    timesheetList: [],
    documents: [],
    file: null,
    loading: false,
    stafflistrequests:[]
};

export default state;